$(function() {

  function initCarouselCounter(e){
    if (!e.namespace)  {
      return;
    }

    var word = "on";
    if ($('html').attr('lang') === 'fr-FR') {
      word = "sur";
    }

    var carousel = e.relatedTarget;
    $(carousel.$element[0]).parent().find('.owl-counter').html('<span>' + (carousel.relative(carousel.current()) + 1) + '</span> ' + word + ' <span>' + carousel.items().length + "</span>");
  }

  $.datepicker.regional.fr = {
    closeText: 'Fermer',
    prevText: 'Précédent',
    nextText: 'Suivant',
    currentText: 'Aujourd\'hui',
    monthNames: ['Janvier','Fevrier','Mars','Avril','Mai','Juin',
    'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'],
    monthNamesShort: ['Jan','Fev','Mar','Avr','Mai','Jun',
    'Jul','Aou','Sep','Oct','Nov','Dec'],
    dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
    dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
    dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
    weekHeader: 'Sm',
    dateFormat: 'dd/mm/yy',
    firstDay: 1,
    showMonthAfterYear: false,
  };

  if ($('html').attr('lang') === 'fr-FR') {
    $.datepicker.setDefaults($.datepicker.regional.fr);
  }

  var dateToday = new Date();
  var yrRange = dateToday.getFullYear() + ":" + (dateToday.getFullYear() + 10);

  //initDatepicker
  $('.input-date')
    .datepicker({
      // Consistent format with the HTML5 picker
      changeMonth: true,
      changeYear: true,
      yearRange: yrRange
    });

  //RESET FORM
  $('input[type="reset"], button[type="reset"]').click(function(e){
    e.preventDefault();
    var form = $(this).parents('form');

    $('input',form)
      .not(':button, :submit, :reset, :hidden')
      .attr('value','')
      .val('')
      .prop('checked', false)
      .prop('selected', false);

    //gestion des select
    $('select',form).each(function(){
      $(this).find('option:first')
      .prop('selected',true);

      //gestion des chosen multiple
      if($(this).attr('class').indexOf('chosen-multiple') != -1) {
        $(this).val([]).trigger('chosen:updated');
        $('.search-choice').remove();
      }

       //Pour les listes des pays, remettre sur la France
      if($(this).attr('id').indexOf('country') != -1) {
        $(this).val(72);
      }
    });

    if($(form).hasClass('c-naturalFormSearch-form')) {
      $('#js-communesNaturalForm').hide();
      $('#js-communesNaturalFormLabel').hide();
    }

    $('textarea',form)
      .val('');

  });

  ////////////////////////////////////////////////////////////////////////
  // GLOBAL VARS

  // Media query init
  var smallDesktopUp = window.matchMedia('(min-width: 960px)');

  /**
   * Init mobile first screen
   * @type {Boolean}
   */
  var screenIsDesktopUp = false;

  function isDesktopUp(e) {
    if (e.matches) {
      screenIsDesktopUp = true;
    } else {
      screenIsDesktopUp = false;
    }
  }

  /**
   * Page content
   * @type {jQuery object}
   */
  var $pageContent = $('#js-o-main');

  ////////////////////////////////////////////////////////////////////////
  // SCROLL
  var $body = $('#js-body');
  var $headerFixed = $('#js-c-header-fixed');

  // If land on Only Lyon Business from an anchor link
  if ($(window).scrollTop() > 0) {
    shrinkHeader();
  }

  /**
   * Add CSS classes for correct display
   */
   function shrinkHeader() {
    $body.addClass('js-body--padded-top');
    $headerFixed.addClass('js-c-header-fixed--minified');
  }

  // On scroll but check only every 100ms thanks to throttle function
  $(window).scroll(throttle(function(e) {
    if ($(this).scrollTop() > 0) {
      shrinkHeader();
    }
    else {
      $body.removeClass('js-body--padded-top');
      $headerFixed.removeClass('js-c-header-fixed--minified');
    }
  }, 100));

  ////////////////////////////////////////////////////////////////////////
  // THROTTLE
  // https://www.grafikart.fr/tutoriels/debounce-throttle-642
  function throttle(callback, delay) {
    var last;
    var timer;
    return function () {
      var context = this;
      var now = +new Date();
      var args = arguments;
      if (last && now < last + delay) {
        // le délai n'est pas écoulé on reset le timer
        clearTimeout(timer);
        timer = setTimeout(function () {
          last = now;
          callback.apply(context, args);
        }, delay);
      } else {
        last = now;
        callback.apply(context, args);
      }
    };
  }

  ////////////////////////////////////////////////////////////////////////
  // MAIN MENU
  var $menuMain = $('#js-c-menuMain');
  var $menuMainButtonOpen = $('#js-c-menuMain-buttonOpen');
  var $menuMainButtonClose = $('#js-c-menuMain-buttonClose');
  var $headerContainerLogoBaseline = $('#js-c-header-containerLogoBaseline');

  $menuMainButtonOpen.on('click', function() {
    if ($menuMain.hasClass('js-c-menuMain--opened')) {
      closeMenuMain();
    }
    else {
      $menuMain.removeAttr('hidden');
      $menuMain.addClass('js-c-menuMain--opened');
      $menuMainButtonOpen.attr('aria-expanded', 'true');
      $menuMainButtonClose.addClass('js-c-menuMain-buttonClose--active');
      $headerContainerLogoBaseline.addClass('js-c-header-containerLogoBaseline--overMenuMain');
    }
  });

  $menuMainButtonClose.on('click', function() {
    closeMenuMain();
  });

  function closeMenuMain() {
    $menuMain.attr('hidden', 'hidden');
    $menuMain.removeClass('js-c-menuMain--opened');
    $menuMainButtonOpen.attr('aria-expanded', 'false');
    $menuMainButtonClose.attr('aria-expanded', 'false');
    $menuMainButtonClose.removeClass('js-c-menuMain-buttonClose--active');
    $headerContainerLogoBaseline.removeClass('js-c-header-containerLogoBaseline--overMenuMain');
  }

  var $menuMainLinksWithSubList = $('#js-c-menuMain-list .c-menuMain-link--hasSubList');

  $menuMainLinksWithSubList.on('click', function(e) {
    e.preventDefault();
    var $currentClickedLink = $(this);
    var $associatedSubList = $(this).next('.c-menuMain-subList');

    if($currentClickedLink.hasClass('c-menuMain-link--active')) {
      closeSubList($currentClickedLink, $associatedSubList, 'c-menuMain-link', 'c-menuMain-subList');
    }
    else {
      var otherActiveLink = $menuMainLinksWithSubList.filter('.c-menuMain-link--active');
      var otherActiveSubList = otherActiveLink.next('.c-menuMain-subList');
      closeSubList(otherActiveLink, otherActiveSubList, 'c-menuMain-link', 'c-menuMain-subList');
      openSubList($currentClickedLink, $associatedSubList, 'c-menuMain-link', 'c-menuMain-subList');
    }
  });

  function openSubList($link, $sublist, linkClass, sublistClass) {
    $link.attr('aria-expanded', 'true');
    $sublist.removeAttr('hidden');
    $link.addClass(linkClass + '--active');
    $sublist.addClass(sublistClass + '--opened');
  }

  function closeSubList($link, $sublist, linkClass, sublistClass) {
    $link.attr('aria-expanded', 'false');
    $sublist.attr('hidden', 'hidden');
    $link.removeClass(linkClass + '--active');
    $sublist.removeClass(sublistClass + '--opened');
  }

  ////////////////////////////////////////////////////////////////////////
  // LANG SWITCHER TODO FACTORIZE
  var langSwitcherList = $('#js-c-langSwitcher-list');
  var langSwitcherButtonToggle = $('#js-c-langSwitcher-buttonToggle');

  $('#js-c-langSwitcher-buttonToggle').append($('#js-c-langSwitcher-current').html());

  langSwitcherButtonToggle.on('click', function() {
    if (langSwitcherList.hasClass('c-langSwitcher-list--opened')) {
      langSwitcherList.attr('hidden', 'hidden');
      langSwitcherList.removeClass('c-langSwitcher-list--opened');
      langSwitcherButtonToggle.attr('aria-expanded', 'false');
      langSwitcherButtonToggle.removeClass('c-langSwitcher-buttonToggle--active');
    }
    else {
      langSwitcherList.addClass('c-langSwitcher-list--opened');
      langSwitcherList.removeAttr('hidden');
      langSwitcherButtonToggle.attr('aria-expanded', 'true');
      langSwitcherButtonToggle.addClass('c-langSwitcher-buttonToggle--active');
    }
  });

  ////////////////////////////////////////////////////////////////////////
  // SEARCH
  var searchContainer = $('#js-c-search');
  var searchButtonOpen = searchContainer.find('#js-c-search-buttonOpen');
  var searchButtonClose = searchContainer.find('#js-c-search-buttonClose');
  var searchOverlay = $('#js-c-search-overlay');

  searchButtonOpen.on('click', function() {
    searchContainer.addClass('c-search--opened');
    searchContainer.attr('aria-expanded', 'true');
    searchOverlay.addClass('js-c-search-overlay--active');
    $("#recherche").focus();
  });

  searchButtonClose.on('click', function() {
    closeSearch(searchContainer, searchOverlay);
  });

  searchOverlay.on('click', function() {
    closeSearch(searchContainer, searchOverlay);
  });

  function closeSearch(search, overlay) {
    search.removeClass('c-search--opened');
    search.attr('aria-expanded', 'false');
    overlay.removeClass('js-c-search-overlay--active');
  }

  ////////////////////////////////////////////////////////////////////////
  // SKIP LINKS
  var $skipLinks = $('#js-c-menuAccess-list .js-c-menuAccess-link');

  $skipLinks.on('click', function(e) {
    e.preventDefault(); // Prevent go to anchor
    $(e.target.hash).focus().click(); // Use anchor as a jQuery selector, focus and click on the selected element
    // focus is used to exit skip links
    // click is used to fire the skip link target (open main menu or search for example)
  });

  ////////////////////////////////////////////////////////////////////////
  // ACCORDIONS TODO FACTORIZE

  var accordionButtons = $('#js-o-main .js-c-accordion-button');

  accordionButtons.on('click', function(e) {
    var currentClickedButton = $(this);
    var associatedAccordionContent = $(this).next('.js-c-accordion-content');

    if(currentClickedButton.hasClass('js-c-accordion-button--active')) {
      closeAccordionContent(currentClickedButton, associatedAccordionContent);
    }
    else {
      openAccordionContent(currentClickedButton, associatedAccordionContent);
    }
  });

  // TODO FACTORIZE WITH DYNAMIC CLASS
  function openAccordionContent(accordionButton, accordionContent) {
    accordionButton.attr('aria-expanded', 'true');
    $(accordionContent).slideDown();
    accordionButton.addClass('js-c-accordion-button--active');
    accordionContent.addClass('js-c-accordion-content--opened');
  }

  // TODO FACTORIZE WITH DYNAMIC CLASS
  function closeAccordionContent(accordionButton, accordionContent) {
    accordionButton.attr('aria-expanded', 'false');
    $(accordionContent).slideUp();
    accordionButton.removeClass('js-c-accordion-button--active');
    accordionContent.removeClass('js-c-accordion-content--opened');
  }

  ////////////////////////////////////////////////////////////////////////
  // MENU ECOSYSTEM
  var menuEcosystemPopin = $('#js-c-menuEcosystem-popin');
  var menuEcosystemButtonOpen = $('#js-c-menuEcosystem-buttonOpen');
  var menuEcosystemButtonClose = $('#js-c-menuEcosystem-buttonClose');
  var menuEcosystemOverlay = $('#js-c-menuEcosystem-overlay');

  menuEcosystemButtonOpen.on('click', function() {
    menuEcosystemOverlay.removeAttr('hidden');
    menuEcosystemPopin.removeAttr('hidden');
    menuEcosystemButtonOpen.attr('aria-expanded', 'true');
    menuEcosystemButtonClose.attr('aria-expanded', 'true');
    menuEcosystemOverlay.addClass('js-c-menuEcosystem-overlay--active');
    menuEcosystemPopin.addClass('c-menuEcosystem-popin--opened');
  });

  menuEcosystemButtonClose.on('click', function() {
    closeMenuEcosystem(menuEcosystemPopin, menuEcosystemOverlay);
  });

  menuEcosystemOverlay.on('click', function() {
    closeMenuEcosystem(menuEcosystemPopin, menuEcosystemOverlay);
  });

  function closeMenuEcosystem(popin, overlay) {
    popin.removeClass('c-menuEcosystem-popin--opened');
    overlay.removeClass('js-c-menuEcosystem-overlay--active');
    menuEcosystemButtonOpen.attr('aria-expanded', 'false');
    menuEcosystemButtonClose.attr('aria-expanded', 'false');
    popin.attr('hidden', 'hidden');
    overlay.attr('hidden', 'hidden');
  }

  /////////////////////////////////////////////////////////////////////
  // AUTOCOMPLETE NATURAL FORM
  $('#js-countriesNaturalForm').autocomplete({
    source: function (request, response) {
      $.ajax({
        url: "/?type=98370&searchChars=" + $('#js-countriesNaturalForm').val(),
        data: { query: request.term },
        success: function (data) {
          var parsed = JSON.parse(data);
          var newArray = new Array(parsed.length);
          var i = 0;

          parsed.forEach(function (entry) {
            var newObject = {
              label: entry.name,
              value: entry.uid,
            };
            newArray[i] = newObject;
            i++;
          });

          response(newArray);
        },
        error: function () {
          response([]);
        }
      });
    },
    select: function (event, ui) {
      event.preventDefault();
      $('#js-countriesNaturalForm').val( ui.item.label);
      if ($('#js-countriesNaturalForm').val() === "France") {
        $('#js-communesNaturalForm').show();
        $('#js-communesNaturalFormLabel').show();
        $('#js-communesNaturalForm').removeAttr('disabled');

      } else {
        $('#js-communesNaturalForm').hide();
        $('#js-communesNaturalFormLabel').hide();
        $('#js-communesNaturalForm').prop('disabled', 'true');
      }
    },
    focus: function(event, ui) {
      event.preventDefault();
      $("#js-countriesNaturalForm").val(ui.item.label);
    },
    minLength: 3,
    delay: 100
  });


  $('#js-communesNaturalForm').autocomplete({
    source: function (request, response) {
      $.ajax({
        url: "/?type=98380&searchChars=" + $('#js-communesNaturalForm').val(),
        data: { query: request.term },
        success: function (data) {
          var parsed = JSON.parse(data);
          var newArray = new Array(parsed.length);
          var i = 0;

          parsed.forEach(function (entry) {
            var newObject = {
              label: entry.name,
              value: entry.uid,
            };
            newArray[i] = newObject;
            i++;
          });

          response(newArray);
        },
        error: function () {
          response([]);
        }
      });
    },
    select: function (event, ui) {
      event.preventDefault();

      //suppression du code postal
      var label = ui.item.label.split(' (')[0];

      $('#js-communesNaturalForm').val( label);
    },
    focus: function(event, ui) {
      event.preventDefault();

      //suppression du code postal
      var label = ui.item.label.split(' (')[0];

      $("#js-communesNaturalForm").val(label);
    },
    minLength: 3,
    delay: 100
  });

  if ($('#js-countriesNaturalForm').val() !== "France") {
    $('#js-communesNaturalForm').hide();
    $('#js-communesNaturalFormLabel').hide();
  }

  // Affiche le champ Communes uniquement si le champ Pays = France sur le Natural Form
  $('#js-countriesNaturalForm').on("input", function () {
    if ($('#js-countriesNaturalForm').val() === "France") {
      $('#js-communesNaturalForm').show();
      $('#js-communesNaturalFormLabel').show();
      $('#js-communesNaturalForm').removeAttr('disabled');

    } else {
      $('#js-communesNaturalForm').hide();
      $('#js-communesNaturalFormLabel').hide();
      $('#js-communesNaturalForm').prop('disabled', 'true');
    }
  });

  ////////////////////////////////////////////////////////////////////////
  // SLIDER CONTACTS ON NATURAL FORM RESULTS (OWL CAROUSEL)
  var $carouselsContainersContacts = $pageContent.find('.js-c-contacts-carousel');

  if ($carouselsContainersContacts.length) {
    // For each contact carousel
    $carouselsContainersContacts.each(function(index) {
      var $currentCarouselContainer = $(this);
      var $currentCarousel = $currentCarouselContainer.find('.js-contactsNaturalFormResults');
      var textDotGeneric = $currentCarouselContainer.find('.js-c-contacts-textDotGeneric').text();
      var textButtonPrevious = $currentCarouselContainer.find('.js-c-contacts-textButtonPrevious').text();
      var textButtonNext = $currentCarouselContainer.find('.js-c-contacts-textButtonNext').text();

      var nbSlides = parseInt($currentCarousel.find('.item').length);
      var showNav = true;
      if (nbSlides < 2) {
        showNav = false;
      }

      $currentCarousel
      .on('initialized.owl.carousel changed.owl.carousel', function(e) {
        initCarouselCounter(e);
      })
      .owlCarousel({
        items: 1,
        nav: showNav,
        dots: false,
        navContainer: $currentCarouselContainer.find('.owl-nav'),
        navText: [
        "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon-contact icon-contact--phone' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites//sprites.svg#icons-arrow-large'></use></svg>",
        "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon icon-contact icon-contact--phone' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites//sprites.svg#icons-arrow-large'></use></svg>",
        ],
        URLhashListener:true,
        startPosition: 'URLHash',
        responsive: {
          0: {
            margin: -120
          },
          480: {
            margin: -200
          },
          768: {
            margin: -400
          },
          960: {
            margin: -150
          },
          1280: {
            margin: -280
          },
          1440: {
            margin: -360
          },
          1920: {
            margin: -600
          }
        }
      });
      makeCarouselDotsAccessible($currentCarouselContainer, textDotGeneric, '.c-contacts-item-name');
      removeFocusOnLinkOwlItemNotActive($currentCarouselContainer);
      $currentCarousel.on('changed.owl.carousel', function (event) {
        $currentCarousel.find($('.owl-item')).find('a').attr('tabindex', -1);
        $currentCarousel.find($('.js-contacts-item-' + (event.item.index + 1))).find('a').removeAttr('tabindex');
      });
    });
  }

  function carouselPagesNaturalFormResults() {
    if ($(window).width() < 768) {

      $('#js-pagesNaturalFormResults').addClass('owl-carousel');

      var textButtonPrevious = $('#js-pagesNaturalFormResults').parent().find('.js-c-textButtonPrevious').text();
      var textButtonNext = $('#js-pagesNaturalFormResults').parent().find('.js-c-textButtonNext').text();

      $('#js-pagesNaturalFormResults')
      .on('initialized.owl.carousel changed.owl.carousel', function(e) {
        initCarouselCounter(e);
      })
      .owlCarousel({
        items: 1,
        nav: true,
        navContainer: $('#js-pagesNaturalFormResults').parent().find('.owl-dots-pages'),
        navText: [
          "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon-contact icon-contact--phone' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites//sprites.svg#icons-arrow-large'></use></svg>",
          "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon icon-contact icon-contact--phone' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites//sprites.svg#icons-arrow-large'></use></svg>",
        ],
        dots: false,
        margin: -55,
        URLhashListener:true,
        startPosition: 'URLHash',
      });
    } else {
      $('#js-pagesNaturalFormResults').owlCarousel('destroy');
      $('#js-pagesNaturalFormResults').removeClass('owl-carousel');
      $('#js-pagesNaturalFormResults').addClass('owl-carousel-off');
    }
  }
  carouselPagesNaturalFormResults();
  $(window).resize(function() {
    carouselPagesNaturalFormResults();
  });

  ////////////////////////////////////////////////////////////////////////
  // SUCCESS STORIES CAROUSEL

  var $carouselsContainersSuccessStoriesMinilist = $pageContent.find('.js-c-successStoriesMinilist-carouselContainer');

  if($carouselsContainersSuccessStoriesMinilist.length) {

    // For each success story carousel
    $carouselsContainersSuccessStoriesMinilist.each(function(index) {
      var $currentCarouselContainer = $(this);
      var $currentCarousel = $currentCarouselContainer.find('.js-c-successStoriesMinilist-list');
      var textDotGeneric = $currentCarouselContainer.find('.js-c-successStoriesMinilist-textDotGeneric').text();
      var textButtonPrevious = $currentCarouselContainer.find('.js-c-successStoriesMinilist-textButtonPrevious').text();
      var textButtonNext = $currentCarouselContainer.find('.js-c-successStoriesMinilist-textButtonNext').text();

      $currentCarousel
      .on('initialized.owl.carousel changed.owl.carousel', function(e) {
        initCarouselCounter(e);
      })
      .owlCarousel({
        items: 1,
        loop: true,
        stagePadding: 41,
        nav: true,
        dots: false,
        navContainer: $currentCarouselContainer.find('.owl-nav'),
        navText: [
        "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon--left' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>",
        "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>"
        ],
        responsive: {
          0: {
            margin: - 14
          },
          480: {
            margin: - 40
          },
          768: {
            items: 2,
            stagePadding: 48, // @TODO FIX
            margin: - 60 // @TODO FIX
          },
          960: {
            items: 2, // @TODO FIX
            margin: - 100 // @TODO FIX
          },
          1280: {
            items: 2,
            stagePadding: 100, // @TODO FIX
            margin: - 100 // @TODO FIX
          },
          1440: {
            items: 2,
            stagePadding: 130, // 1 col 94px + 1 gutter 24px + 1/2 gutter 12px
            margin: - 112 // @TODO FIX : This breaks almost perfect CSS layout but half hidden item is OK
          },
          1600: {
            items: 2,
            stagePadding: 130, // @TODO FIX
            margin: - 150, // This breaks CSS layout but half hidden item is OK
          },
          1920: {
            items: 2,
            stagePadding: 200, // @TODO FIX
            margin: - 150 // This breaks CSS layout but half hidden item is OK
          }
        }
      });
      makeCarouselDotsAccessible($currentCarouselContainer, textDotGeneric, '.c-successStoriesMinilist-itemTitle');
    });
  }

  /**
   * Add accessible text for carousel dots
   * @param  {jquery object} $carouselContainer Targeted carousel container
   * @param  {string} labelGeneric       todo desc
   * @param  {string} itemTitleClass     Item title class to get item title text
   */
   function makeCarouselDotsAccessible($carouselContainer, labelGeneric, itemTitleClass) {
    $carouselContainer.find('.owl-dots .owl-dot').each( function (index) {
      var itemNumber = index + 1;
      var $span = $(this).find('span');
      $span.addClass('u-sr-only');

      if(itemTitleClass) {
        var itemTitleText = $carouselContainer.find(itemTitleClass).eq(index).text();
        $span.html(labelGeneric + ' ' + itemNumber + ' : "' + itemTitleText + '"');
      }
      else {
        $span.html(labelGeneric + ' ' + itemNumber);
      }
    });
  }

  // Remove focus on element not active in Owl Carousel
  function removeFocusOnLinkOwlItemNotActive($currentCarouselContainer) {
    $currentCarouselContainer.find($('.owl-item')).each(function () {
      if (!($(this).hasClass('active'))) {
        $(this).find('a').attr('tabindex', -1);
      } else {
        $(this).find('a').removeAttr('tabindex');
      }
    });
  }

  ////////////////////////////////////////////////////////////////////////
  // CONTACTS
  var noResults, projectPH, sectorPH, themePH, contentTypePH;
  if ($('html').attr('lang') === 'fr-FR') {
    noResults = 'Aucun résultat trouvé pour ';
    projectPH = 'Votre projet';
    sectorPH = 'Votre secteur d\'activité';
    themePH = 'Thématiques';
    contentTypePH = 'Type de contenu';
  } else{
    noResults = 'No results for ';
    projectPH = 'Your project';
    sectorPH = 'Your business sector';
    themePH = 'Themes';
    contentTypePH = 'Content type';
  }

  $('.chosen-multiple-project').chosen({
    placeholder_text_multiple: projectPH,
    no_results_text: noResults
  });

  $('.chosen-multiple-sector').chosen({
    placeholder_text_multiple: sectorPH,
    no_results_text: noResults
  });

  $('.chosen-multiple-theme').chosen({
    placeholder_text_multiple: themePH,
    no_results_text: noResults,
    width: '100%'
  });

  $('.chosen-multiple-contentType').chosen({
    placeholder_text_multiple: contentTypePH,
    no_results_text: noResults,
    width: '100%'
  });

  $(".chosen-search-input", "#projects_chosen").attr('placeholder',projectPH);
  $(".chosen-search-input", "#activities_sector_chosen").attr('placeholder',sectorPH);
  $(".chosen-search-input", "#themes_chosen").attr('placeholder',contentTypePH);

  $('.search-choice').appendTo('#js-contacts-form-filterChoices');
  $('.chosen-multiple-project, .chosen-multiple-sector').change(function () {
    $('.search-choice').appendTo('#js-contacts-form-filterChoices');
  });

  $('.search-choice').appendTo('#js-records-form-filterChoices');
  $('.chosen-multiple-theme, .chosen-multiple-contentType').change(function () {
    $('.search-choice').appendTo('#js-records-form-filterChoices');
  });

  if ($(window).width() < 960) {
    $('#js-contacts-form').hide();
    $('#js-contacts-buttonFormToggle').click(function () {
      $('#js-contacts-form').slideToggle('fast', 'swing', function () {
        if ($('#js-contacts-form').is(":hidden")) {
          $('.c-contacts-buttonFormToggle-icon use').attr('xlink:href', $('.c-contacts-buttonFormToggle-icon use').attr('xlink:href').replace('#icons-moins', '#icons-plus'));
        } else {
          $('.c-contacts-buttonFormToggle-icon use').attr('xlink:href', $('.c-contacts-buttonFormToggle-icon use').attr('xlink:href').replace('#icons-plus', '#icons-moins'));
        }
      });
    });
  }


  if ($(window).width() < 960) {
    $('#js-records-form, .js-records-form').hide();
    $('#js-records-buttonFormToggle').click(function () {
      $('#js-records-form, .js-records-form').slideToggle('fast', 'swing', function () {
        if ($('#js-records-form, .js-records-form').is(":hidden")) {
          $('#js-records-buttonFormToggle-icon use').attr('xlink:href', $('#js-records-buttonFormToggle-icon use').attr('xlink:href').replace('#icons-moins', '#icons-plus'));
        } else {
          $('#js-records-buttonFormToggle-icon use').attr('xlink:href', $('#js-records-buttonFormToggle-icon use').attr('xlink:href').replace('#icons-plus', '#icons-moins'));
        }
      });
    });
  }

  ////////////////////////////////////////////////////
  // GALLERY PHOTO
  var $galleries = $pageContent.find('.js-c-gallery');

  if($galleries.length > 0) {

    // For each gallery
    $galleries.each(function(index) {
      var $currentCarouselContainer = $(this).find('.js-c-gallery-container');
      var $currentCarousel = $currentCarouselContainer.find('.js-c-gallery-list');
      var textDotGeneric = $currentCarouselContainer.find('.js-c-gallery-textDotGeneric').text();
      var textButtonPrevious = $currentCarouselContainer.find('.js-c-textButtonPrevious').text();
      var textButtonNext = $currentCarouselContainer.find('.js-c-textButtonNext').text();

      $currentCarousel
      .on('initialized.owl.carousel changed.owl.carousel', function(e) {
        initCarouselCounter(e);
      })
      .owlCarousel({
        items: 2,
        loop: true,
        dots: false,
        dotsEach: 1,
        dotsContainer: $currentCarouselContainer.find('.owl-dots'),
        nav: true,
        navContainer: $currentCarouselContainer.find('.owl-nav'),
        navText: [
        "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon--left' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>",
        "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>"
        ],
        stagePadding: 30,
        responsive: {
          0: {
            items: 1
          },
          960: {
            stagePadding: 80
          },
          1280: {
            stagePadding: 112
          },
          1440: {
            stagePadding: 130
          },
          1600: {
            items: 3,
            stagePadding: 144
          },
          1920: {
            items: 3,
            stagePadding: 176
          }
        }
      });
      makeCarouselDotsAccessible($currentCarouselContainer, textDotGeneric);
    });
  }

  ////////////////////////////////////////////////////////////////////////
  // SOCIALS ADDTOANY + Tarteaucitron
  var $share = $('#js-c-share');

  if($share.length > 0) {
    var $buttonShare = $share.find('#addtoany_allow');
    var addtoany_inlineshare = document.getElementById('addtoany_inline_share');
    var tac_container = document.getElementById('tac_container');;
    var $addtoany_allow = $('#addtoany_allow');
    var addtoanyAccepted = false;

    $(addtoany_inlineshare).hide();

    $buttonShare.on('click', function() {
      $buttonShare.toggleClass('c-share-buttonShare--active');
      $share.toggleClass('js-c-share--opened');
      if(addtoanyAccepted){
        $(addtoany_inlineshare).toggle();
      }
    });

    if($(addtoany_inlineshare).length > 0) {

      if (!addtoanyAccepted) {
        // Observe childList
        var config = { childList: true };

        // Callback to launch when a mutation is observed
        var callback = function(mutationsList) {
          
          for(var i = 0; i < mutationsList.length; i++) {
            // If mutation in child elements
            if (mutationsList[i].type == 'childList') {

              if($(addtoany_inlineshare).find('.a2a_svg').length > 0){
                addtoanyAccepted = true;
              }

              var $realButtonAllowAddtoany = $(tac_container).find('.tarteaucitronAllow');
              // Check if tarteaucitron has been init
              if($realButtonAllowAddtoany.length > 0) {
                $('.tarteaucitronAllow','#tarteaucitronRoot').on('click', function() {
                  addtoanyAccepted = true;
                  $(addtoany_inlineshare).show();
                });
                $('.tarteaucitronDeny','#tarteaucitronRoot').on('click', function() {
                  addtoanyAccepted = false;
                  $(addtoany_inlineshare).hide();
                });

                // Stop observer, don't need it anymore
                observer.disconnect();

                // Get hidden HTML (icon)
                var iconButtonAlowAddtoany = $('#js-c-cookies-buttonValidate').html();

                // Replace default tarteaucitron text with our HTML
                $realButtonAllowAddtoany.html(iconButtonAlowAddtoany + tarteaucitron.lang.allow);
                // Disable warning: Functions declared within loops referencing an outer
                // scoped variable may lead to confusing semantics:
                /*jshint -W083 */
                $realButtonAllowAddtoany.on('click', function(e){
                  $(addtoany_inlineshare).show();
                  addtoanyAccepted = true;
                });
              }
            }
          }
        };

        // Create the observer
        var observer = new MutationObserver(callback);

        // Observe addthis_forbidden to check if DOM inside has changed with tarteaucitron
        observer.observe(addtoany_inlineshare, config);
        observer.observe(tac_container, config);
      }
    }
  }

  ////////////////////////////////////////////////////////////////////////
  // NEWS CAROUSEL

  var $carouselsContainersNewsMinilist = $pageContent.find('.js-c-newsMinilist-carouselContainer');

  if($carouselsContainersNewsMinilist.length) {

    // For each success story carousel
    $carouselsContainersNewsMinilist.each(function(index) {
      var $currentCarouselContainer = $(this);
      var $currentCarousel = $currentCarouselContainer.find('.js-c-newsMinilist-list');
      var textDotGeneric = $currentCarouselContainer.find('.js-c-newsMinilist-textDotGeneric').text();
      var textButtonPrevious = $currentCarouselContainer.find('.js-c-newsMinilist-textButtonPrevious').text();
      var textButtonNext = $currentCarouselContainer.find('.js-c-newsMinilist-textButtonNext').text();

      $currentCarousel
      .on('initialized.owl.carousel changed.owl.carousel', function(e) {
        initCarouselCounter(e);
      })
      .owlCarousel({
        items: 1,
        loop: true,
        center: true,
        margin: 30,
        stagePadding: 30,
        nav: true,
        dots: false,
        navContainer: $currentCarouselContainer.find('.owl-nav'),
        navText: [
        "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon--left' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>",
        "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>"
        ],
        responsive: {
          0: {
            margin: 30,
            stagePadding: 50,
          },
          480: {
            margin: 50,
            stagePadding: 80,
          },
          768: {
            margin: 100,
            stagePadding: 200,
          },
          960: {
            items: 3, // @TODO FIX
            margin: 50,
            stagePadding: 80,
          },
          1280: {
            items: 3,
            margin: 50,
            stagePadding: 80,
          },
          1440: {
            items: 3,
            margin: 80,
            stagePadding: 150,
          },
          1600: {
            items: 3,
            margin: 100,
            stagePadding: 200,
          },
          1920: {
            items: 3,
            margin: 120,
            stagePadding: 250,
          },
        }
      });
      makeCarouselDotsAccessible($currentCarouselContainer, textDotGeneric, '.c-newsMinilist-itemTitle');
    });
  }

  ////////////////////////////////////////////////////////////////////////
  // AGENDA CAROUSEL

  var $carouselsContainersAgendaMinilist = $pageContent.find('.js-c-agendaMinilist-carouselContainer');

  if($carouselsContainersAgendaMinilist.length) {

    isDesktopUp(smallDesktopUp);

    // Add a listen event
    smallDesktopUp.addListener(isDesktopUp);

    // Init
    carouselsAgendaMinilistDealWithCarousels($carouselsContainersAgendaMinilist);

    // On screen width change
    smallDesktopUp.onchange = function() {
      carouselsAgendaMinilistDealWithCarousels($carouselsContainersAgendaMinilist);
    };

  }

  // Function to do something with the media query
  function carouselsAgendaMinilistDealWithCarousels($carouselsContainers) {

    // For each agenda carousel
    $carouselsContainersAgendaMinilist.each(function(index) {
      var $currentCarouselContainer = $(this);
      var $currentCarousel = $currentCarouselContainer.find('.js-c-agendaMinilist-list');
      var textButtonPrevious = $currentCarouselContainer.find('.js-c-agendaMinilist-textButtonPrevious').text();
      var textButtonNext = $currentCarouselContainer.find('.js-c-agendaMinilist-textButtonNext').text();
      // Don't create carousel on desktop
      if (screenIsDesktopUp) {
        // If carousel already exists (after a resize for example)
        if($currentCarousel.hasClass('owl-loaded')) {
          $currentCarousel.owlCarousel('destroy');
        }
        $currentCarousel.removeClass('owl-carousel');

      } else {
        if(!$currentCarousel.hasClass('owl-carousel')) {
          // owlCarousel('destroy') remove totally owl-dots so it is required to add them again
          $currentCarouselContainer.find('.owl-controls').prepend('<div class="owl-dots"></div>');
          $currentCarousel.addClass('owl-carousel');
        }
        var textDotGeneric = $currentCarouselContainer.find('.js-c-agendaMinilist-textDotGeneric').text();
        createCarouselAgendaMinilist($currentCarouselContainer, $currentCarousel, textButtonPrevious, textButtonNext);
        makeCarouselDotsAccessible($currentCarouselContainer, textDotGeneric, '.c-agendaMinilist-itemTitle');
      }
    });
  }

  function createCarouselAgendaMinilist($currentCarouselContainer, $currentCarousel, textButtonPrevious, textButtonNext) {

    $currentCarousel
    .on('initialized.owl.carousel changed.owl.carousel', function(e) {
      initCarouselCounter(e);
    })
    .owlCarousel({
      items: 1,
      loop: true,
      dotsContainer: $currentCarouselContainer.find('.owl-dots'),
      dotsEach: 1,
      dots: false,
      nav: true,
      navContainer: $currentCarouselContainer.find('.owl-nav'),
      navText: [
        "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon--left' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>",
        "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>"
      ],
      responsive: {
        0: {
          stagePadding: 28,
        },
        768: {
          items: 2,
          stagePadding: 0,
        }
      }
    });

  }

  ////////////////////////////////////////////////////////////////////////
  // SERVICES CAROUSEL

  var $servicesList = $('#js-c-servicesList');

  // If page Services
  if($servicesList.length > 0) {
    var $carouselsContainersServicesSubLists = $servicesList.find('.js-c-servicesList-subList-carouselContainer');

    // If page Services has sub services
    if ($carouselsContainersServicesSubLists.length > 0) {
      // Add a listen event
      smallDesktopUp.addListener(handleCarouselsServicesSubLists);

      // On load
      handleCarouselsServicesSubLists(smallDesktopUp);
    }
  }

  function resetCarousel($carousel) {
    if($carousel.hasClass('owl-loaded')) {
      $carousel.owlCarousel('destroy');
    }
    $carousel.removeClass('owl-carousel');
  }

  function initCarousel($carousel) {
    if(!$carousel.hasClass('owl-carousel')) {
      $carousel.addClass('owl-carousel');
    }
  }

  // Function to do something with the media query
  function handleCarouselsServicesSubLists(mediaQuery) {

    // For each carousel
    $carouselsContainersServicesSubLists.each(function(index) {
      var $currentCarouselContainer = $(this);
      var $currentCarouselServicesSubList = $currentCarouselContainer.find('.js-c-servicesList-subList');

      if (mediaQuery.matches) {
        // Don't create carousel on desktop
        resetCarousel($currentCarouselServicesSubList);
      } else {
        // Create carousel on mobile
        initCarousel($currentCarouselServicesSubList);
        createCarouselServicesSubList($currentCarouselServicesSubList, $currentCarouselContainer);
      }
    });
  }

  function createCarouselServicesSubList($carousel, $carouselContainer) {
    var textDotGeneric = $('#js-c-servicesList-textDotGeneric').text();

    var textButtonPrevious = $carouselContainer.find('.js-c-textButtonPrevious').text();
    var textButtonNext = $carouselContainer.find('.js-c-textButtonNext').text();

    $carousel
    .on('initialized.owl.carousel changed.owl.carousel', function(e) {
      initCarouselCounter(e);
    })
    .owlCarousel({
      items: 1,
      loop: true,
      dots: false,
      nav: true,
      navContainer: $carouselContainer.find('.owl-nav'),
      navText: [
        "<span class='u-sr-only'>" + textButtonPrevious + "</span><svg class='icon icon--left' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>",
        "<span class='u-sr-only'>" + textButtonNext + "</span><svg class='icon' aria-hidden='true'><use xlink:href='/typo3conf/ext/gl_onlybusiness_config/Resources/Public/images/sprites/sprites.svg#icons-arrow-large'></use></svg>"
      ],
      responsive: {
        0: {
          stagePadding: 40,
        },
        360: {
          stagePadding: 70,
        },
        480: {
          stagePadding: 110,
        },
        624: {
          items: 2,
          stagePadding: 65,
        },
        768: {
          items: 3,
          stagePadding: 30,
        },
        860: {
          items: 3,
          stagePadding: 60,
        }
      }
    });

    makeCarouselDotsAccessible($carouselContainer, textDotGeneric);
  }

  ////////////////////////////////////////////////////////////////////////
  // MENU ANCHORS
  // @TODO FACTORIZE WITH MENU ECOSYSTEM
  var $menuAnchorsPopin = $('#js-c-menuAnchorsMobile-popin');
  var $menuAnchorsLinks = $menuAnchorsPopin.find('.c-menuAnchorsMobile-link');
  var $menuAnchorsButtonOpen = $('#js-c-menuAnchorsMobile-buttonOpen');
  var $menuAnchorsButtonClose = $('#js-c-menuAnchorsMobile-buttonClose');
  var $menuAnchorsOverlay = $('#js-c-menuAnchorsMobile-overlay');

  $menuAnchorsButtonOpen.on('click', function() {
    $menuAnchorsOverlay.removeAttr('hidden');
    $menuAnchorsPopin.removeAttr('hidden');
    $menuAnchorsButtonOpen.attr('aria-expanded', 'true');
    $menuAnchorsButtonClose.attr('aria-expanded', 'true');
    $menuAnchorsOverlay.addClass('js-c-menuAnchorsMobile-overlay--active');
    $menuAnchorsPopin.addClass('c-menuAnchorsMobile-popin--opened');
  });

  $menuAnchorsButtonClose.on('click', function() {
    closeMenuAnchors($menuAnchorsPopin, $menuAnchorsOverlay);
  });

  $menuAnchorsOverlay.on('click', function() {
    closeMenuAnchors($menuAnchorsPopin, $menuAnchorsOverlay);
  });

  $menuAnchorsLinks.on('click', function() {
    closeMenuAnchors($menuAnchorsPopin, $menuAnchorsOverlay);
  });

  function closeMenuAnchors(popin, overlay) {
    popin.removeClass('c-menuAnchorsMobile-popin--opened');
    overlay.removeClass('js-c-menuAnchorsMobile-overlay--active');
    $menuAnchorsButtonOpen.attr('aria-expanded', 'false');
    $menuAnchorsButtonClose.attr('aria-expanded', 'false');
    popin.attr('hidden', 'hidden');
    overlay.attr('hidden', 'hidden');
  }

  ////////////////////////////////////////////////////////////////////////
  // CONTENT tarteaucitron for VIDEOS (YouTube and Vimeo)
  var videos = document.getElementById('js-o-main').getElementsByClassName('video-embed');

  if(videos.length) {
    // Put an observer only to last item in order to modify all videos at the same time
    var lastVideo = videos[videos.length - 1].firstElementChild;

    // Observe childList
    var lastVideoConfig = { childList: true };

    // Callback to launch when a mutation is observed
    var lastVideoCallback = function(mutationsList) {
      for(var i = 0; i < mutationsList.length; i++) {

        // If mutation in child elements
        if (mutationsList[i].type == 'childList') {

          // Stop observer, don't need it anymore
          lastVideoObserver.disconnect();

          // Check if tarteaucitron buttons exist
          if(lastVideo.getElementsByClassName('tarteaucitronAllow').length) {

            // Get hidden HTML (icon)
            var iconButtonAllow = $('#js-c-cookies-buttonValidate').html();

            // Remove inline height and width on Vimeo player
            $('.vimeo_player').removeAttr("style");

            // Get all videos tarteaucitron buttons all
            var $allVideos = $pageContent.find('.video-embed .tarteaucitronAllow');

            // // Replace default tarteaucitron text with our HTML
            $allVideos.html(iconButtonAllow + tarteaucitron.lang.allow);
          }
        }
      }
    };

    // Create the observer
    var lastVideoObserver = new MutationObserver(lastVideoCallback);

    // Observe body to check if DOM inside has changed
    lastVideoObserver.observe(lastVideo, lastVideoConfig);
  }

  $('.vimeo_player').removeAttr("style");

  ////////////////////////////////////////////////////////////////////////
  // COOKIES tarteaucitron
  var body = document.getElementById('js-body');

  // Observe childList
  var bodyConfig = { childList: true };

  // Callback to launch when a mutation is observed
  var bodyCallback = function(mutationsList) {
    for(var i = 0; i < mutationsList.length; i++) {
      // If mutation in child elements
      if (mutationsList[i].type == 'childList') {

        // Check if tarteaucitron buttons exist
        if($('#tarteaucitronPersonalize2').length && $('#tarteaucitronCloseAlert').length) {
          // Stop observer, don't need it anymore
          bodyObserver.disconnect();

          // Get hidden HTML (icon)
          var htmlButtonValidate = $('#js-c-cookies-buttonValidate').html();
          var htmlButtonCustomize = $('#js-c-cookies-buttonCustomize').html();
          var htmlButtonDenied = $('#js-c-cookies-buttonDenied').html();

          // Target tarteaucitron buttons
          var $tarteaucitronPersonalize = $('#tarteaucitronPersonalize2');
          var $tarteaucitronCloseAlert = $('#tarteaucitronCloseAlert');
          var $tarteaucitronDeny = $('#tarteaucitronAllDenied2');

          // Replace default tarteaucitron buttons with our icon + tarteaucitron texts
          $tarteaucitronPersonalize.html(htmlButtonValidate + tarteaucitron.lang.acceptAll);
          $tarteaucitronCloseAlert.html(htmlButtonCustomize + tarteaucitron.lang.personalize);
          $tarteaucitronDeny.html(htmlButtonDenied + tarteaucitron.lang.denyAll);
        }
      }
    }
  };

  // Create the observer
  var bodyObserver = new MutationObserver(bodyCallback);

  // Observe body to check if DOM inside has changed
  bodyObserver.observe(body, bodyConfig);


  ////////////////////////////////////////////////////////////////////////
  // MENU SECONDARY (DUPLICATED FROM MAIN MENU, COULD BE FACTORIZED)
  var $menuSecondary = $('#js-c-menuSecondary');
  var $menuSecondaryButtonOpen = $('#js-c-menuSecondary-buttonOpen');
  var $menuSecondaryButtonClose = $('#js-c-menuSecondary-buttonClose');

  $menuSecondaryButtonOpen.on('click', function() {
    if ($menuSecondary.hasClass('js-c-menuSecondary--opened')) {
      closeMenuSecondary();
    }
    else {
      openMenuSecondary();
    }
  });

  $menuSecondaryButtonClose.on('click', function() {
    closeMenuSecondary();
  });

  function openMenuSecondary() {
    $menuSecondary.removeAttr('hidden');
    $menuSecondary.addClass('js-c-menuSecondary--opened');
    $menuSecondaryButtonOpen.attr('aria-expanded', 'true');
    $menuSecondaryButtonOpen.addClass('js-c-menuSecondary-buttonOpen--active');
    $menuSecondaryButtonClose.attr('aria-expanded', 'true');
    $menuSecondaryButtonClose.addClass('js-c-menuSecondary-buttonClose--active');
  }

  function closeMenuSecondary() {
    $menuSecondary.attr('hidden', 'hidden');
    $menuSecondary.removeClass('js-c-menuSecondary--opened');
    $menuSecondaryButtonOpen.attr('aria-expanded', 'false');
    $menuSecondaryButtonOpen.removeClass('js-c-menuSecondary-buttonOpen--active');
    $menuSecondaryButtonClose.attr('aria-expanded', 'false');
    $menuSecondaryButtonClose.removeClass('js-c-menuSecondary-buttonClose--active');
  }

  var $menuSecondaryLinksWithSubList = $('#js-c-menuSecondary-list .c-menuSecondary-link--hasSubList');

  $menuSecondaryLinksWithSubList.on('click', function(e) {
    e.preventDefault();
    var $currentClickedLink = $(this);
    var $associatedSubList = $(this).next('.c-menuSecondary-subList');

    if($currentClickedLink.hasClass('c-menuSecondary-link--active')) {
      closeSubList($currentClickedLink, $associatedSubList, 'c-menuSecondary-link', 'c-menuSecondary-subList');
    }
    else {
      var otherActiveLink = $menuSecondaryLinksWithSubList.filter('.c-menuSecondary-link--active');
      var otherActiveSubList = otherActiveLink.next('.c-menuSecondary-subList');
      closeSubList(otherActiveLink, otherActiveSubList, 'c-menuSecondary-link', 'c-menuSecondary-subList');
      openSubList($currentClickedLink, $associatedSubList, 'c-menuSecondary-link', 'c-menuSecondary-subList');
    }
  });

  $('.photoCompo-imgWrapper-img').fancybox({
    'loop': true,
    'showNavArrows': true
  });
});

function scrollToAnchor(hash) {
  var target = $(hash),
      headerHeight = $(".c-header-fixed").height(); // Get fixed header height

  target = target.length ? target : $('[name=' + hash.slice(1) +']');

  if (target.length)
  {
    $('html,body').animate({
      scrollTop: target.offset().top - headerHeight
    }, 100);
    return false;
  }
}

if(window.location.hash) {
  scrollToAnchor(window.location.hash);
}

$("a[href*=\\#]:not([href=\\#])").click(function()
{
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname)
  {

    scrollToAnchor(this.hash);
  }
});
